<template>
    <div class="sign">
        <el-form class="sign-form" :model="signForm" :rules="signRules" ref="signForm" label-width="0px">
            <el-tabs  v-model="activeName" @tab-click="handleClick">
                <el-tab-pane  label="快捷登录" name="0">
                    <template v-if="activeName=='0'">
                        <el-form-item prop="phone">
                            <el-input v-model="signForm.phone" :maxlength="11" type="text" size="large" autocomplete="off" placeholder="请输入手机号" oninput="value=value.replace(/[^\d]/g,'')">
                                <template slot="prefix">
                                <!-- <svg-icon icon-class="user" class="icon-margin" /> -->
                                    <i class="el-icon-user"/>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="code">
                            <el-input class="input-code-padding" v-model="signForm.code" :maxlength="6"  type="text" size="large" placeholder="请输入短信验证码" oninput="value=value.replace(/[^\d]/g,'')">
                                <template slot="prefix">
                                    <i class="el-icon-mobile-phone"/>
                                </template>
                                <template slot="suffix">
                                    <el-button class="code-button" type="primary" size="large" :disabled="codeTime>0" @click="getCode"> {{codeTime === 0 ? '获取验证码' : codeTime + 's后获取'}}</el-button>
                                </template>
                            </el-input>
                        </el-form-item>
                    </template>
                </el-tab-pane>
                <el-tab-pane label="密码登录" name="1">
                    <template v-if="activeName=='1'">
                        <el-form-item prop="phone">
                            <el-input class="mobile-input" v-model="signForm.phone" :maxlength="11" type="text" size="large" autocomplete="off" placeholder="请输入手机号" oninput="value=value.replace(/[^\d]/g,'')">
                                <template slot="prefix">
                                    <i class="el-icon-user"/>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input  class="password-input"  v-model="signForm.password" :maxlength="20" type="password" size="large" autocomplete="off" placeholder="请输入密码"  >
                                <template slot="prefix">
                                    <i class="el-icon-lock"/>
                                </template>
                            </el-input>
                        </el-form-item>
                        <p class="password-tips" @click="changeSign">忘记密码？</p>
                    </template>
                </el-tab-pane>
            </el-tabs>
            <el-form-item>
                <el-button class="submit-btn" size="large" type="primary" :loading="loading" @click="submitForm">登录</el-button>
            </el-form-item>
        </el-form>  
        <verificationCode v-model="isImgCode" :phone="signForm.phone" @close="isImgCode=false"/> 
    </div>
</template>

<script>
import verificationCode from './components/verificationCode.vue'
import mixin from './mixni/mixni.js'
import { validatePhone } from "@/utils/validate";
import { mapMutations, mapActions ,mapState} from "vuex"; 
// import {
//   AccountRoutes
// } from '@/router'
export default {
    mixins: [mixin],
    components:{
        verificationCode
    },
    data() {
        const validatorMobile = (rule, value, callback) => {
            if (!validatePhone(value)) {
                callback(new Error("请输入正确的手机号"));
            } else {
                callback();
            }
        };
        return {
            // AccountRoutes,
            activeName: '0',
            codeUrl:'',
            signForm: {
                phone: '',
                imgCode:'',
                code:'',
                password:'',
            },
            signRules: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: validatorMobile, trigger: "blur" }
                ],
                imgCode: [
                    { required: true, message: '请输入图片验证码', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入短信验证码', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ]
            },
            loading:false,
            isImgCode:false,
        }
    },
    computed:{
        ...mapState({
            AccountRoutes: state => state.user.AccountRoutes,
        })
    },
    methods: {
        ...mapActions([
            'Login',
            'QuickLogin'
        ]),
        // 重置表单
        handleClick(tab, event) {
            this.clearTimer()
            this.$refs.signForm.resetFields()
        },
        // 获取短信验证码
        getCode(){
            if(!this.signForm.phone)return
            const obj = { phone : this.signForm.phone, type : "sms_login" }
            this.getSmsCode(obj)
        },
        submitForm() {
            this.$refs.signForm.validate((valid) => {
                if (valid) {
                    this.activeName=='0'?this.quickLogin():this.login();
                } else {
                    return false;
                }
            });
        },
        quickLogin(){
            const data = {
                phone:this.signForm.phone,
                code:this.signForm.code
            }
            this.loading = true
            this.QuickLogin(data).then(res=>{
                this.$toast({
                    type: 'success',
                    message: '登录成功',
                    duration: 2000
                })
                this.loading = false
                // this.$router.push({ path: "/index" });
                // 权限路由
                this.goMain()
            }).catch(err=>{
                this.loading = false
            })
        },
        login(){
            const data = {
                phone:this.signForm.phone,
                password:this.signForm.password
            }
            this.loading = true
            this.Login(data).then(res=>{
                this.$toast({
                    type: 'success',
                    message: '登录成功',
                    duration: 2000
                })
                this.loading = false
                // 权限路由
                this.goMain()
            }).catch(err=>{
                this.loading = false
                if(err.data.code==115){
                    this.isImgCode = true
                }
            })
        },
        changeSign(){
            this.$refs.signForm.resetFields()
            this.$emit('changeSign')
        },

        // 根据权限跳转
        goMain(){
            if(this.AccountRoutes[0].children){
                if(this.AccountRoutes[0].children[0].children){
                    this.$router.push({name:this.AccountRoutes[0].children[0].children[0].name})
                    console.log(this.AccountRoutes[0].children[0].children[0].name)
                }else{
                    this.$router.push({name:this.AccountRoutes[0].children[0].name})
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.sign-form{
    /deep/ .el-tabs{
        .el-tabs__nav-scroll{
            margin-bottom: 20px;
        }
        .el-tabs__item{
            color: #999999;
            font-size: 20px;
            &:hover{
                color: #333333; 
            }
        }
        .is-active{
            color: #333333; 
        }
        .el-tabs__nav-wrap::after{
            opacity: 0;
        }
    }
    /deep/.el-form-item{
        margin-bottom: 40px;
        .el-form-item__content{
            .el-input__prefix{
                color: #333333;
                font-size: 18px;
                display: flex;
                align-items: center;
                left: 16px;
                &::after{
                    content:'';
                    display: block;
                    width: 1px;
                    height: 50%;
                    margin-left: 10px;
                    background: #999999;
                }
                .el-input__icon{
                    line-height: 50px;
                }
            }
            .el-input__inner{
                height: 50px;
                font-size: 15px;
                padding-left: 60px;
            }
            .el-input__suffix{
                top:1px
            }
            .code-img-button,
            .code-button{
                height: 48px;
                margin-right: -4px;
                border-radius: 0px 4px 4px 0;
            }
            .code-img-button{
                width: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(0,0,0,0.2);
            }
            // .code-button{
            //     width: 150px; 
            // }
        }
        .submit-btn{
            width: 100%;
            height: 50px;
        }
    }
    .password-tips{
        color: #54cfb3;
        font-size: 18px;
        text-align: right;
        cursor: pointer;
        line-height: 24px;
        margin-top: -35px;
    }
    // 图片验证码 input padding值
    .input-img-code-padding{
        .el-input__inner{
            padding-right: 120px;
        }
    }
    // 短信验证码 input padding值
    .input-code-padding{
        .el-input__inner{
            padding-right: 150px;
        }
    }
}
</style>